import { createContext, FunctionComponent, useContext, useEffect, useState } from "react";
import RateAgreementService from "../services/RateAgreementService";
import TenantService, { Tenant } from "../services/TenantService/TenantService";
import { RateAgreementTenantConfiguration } from "../types/RateAgreementTenantConfiguration";

type TenantContextType = {
    tenant?: Tenant;
    rateAgreementTenantConfiguration?: RateAgreementTenantConfiguration;
};

const TenantContext = createContext<TenantContextType>({});

export const TenantProvider: FunctionComponent = ({ children }) => {
    const [tenant, setTenant] = useState<Tenant>();
    const [rateAgreementTenantConfiguration, setRateAgreementTenantConfiguration] = useState<RateAgreementTenantConfiguration>();

    useEffect(() => {
        (async function fetchTenant() {
            const [tenant, config] = await Promise.all([TenantService.getTenant(), RateAgreementService.getTenantConfiguration()]);
            setTenant(tenant);
            setRateAgreementTenantConfiguration(config);
        })();
    }, []);

    return <TenantContext.Provider value={{ tenant, rateAgreementTenantConfiguration }}>{children}</TenantContext.Provider>;
};

export const useTenant = () => {
    return useContext(TenantContext);
};

export const useCurrency = () => {
    const { tenant } = useContext(TenantContext);
    return tenant?.currency;
};

export const useRateAgreementTenantConfiguration = () => {
    const { rateAgreementTenantConfiguration } = useContext(TenantContext);
    return rateAgreementTenantConfiguration;
};
